module.exports = __webpack_public_path__ + "static/media/bg.e7374abd.png";